import ReactDOM from 'react-dom';
import App from './App';
import Login from './screens/Login';

if (localStorage.getItem('adsnetwork_token') === '123') {
  ReactDOM.render(<App />, document.getElementById('root'));
} else {
  ReactDOM.render(<Login />, document.getElementById('root'));
}